export enum CASTSTATUS {
    "Awaiting Verification"='Ready',
    "Created" = 'Queued',
    "In Progress"='Processing'
}
export enum STATUS {
    AwaitingVerification='Awaiting Verification',
    Created = 'Created',
    InProgress='In Progress'
}


export enum Agent {
    Alera ='Alera',
    Veris = 'Veris',
    Revio = 'Revio'
}

export enum AgentAlera {
    
}

